module.exports = __webpack_public_path__ + "img/logo2.01ad86f3.png";